export const UPDATE_STATION = 'UPDATE_STATION';
export const UPDATE_TYPE = 'UPDATE_TYPE';
export const UPDATE_SKILLS = 'UPDATE_SKILLS';
export const UPDATE_COND = 'UPDATE_COND';
export const UPDATE_INFO = 'UPDATE_INFO';
export const UPDATE_CONF = 'UPDATE_CONF';
export const CHANGE_MODIFY_MODE = 'CHANGE_MODIFY_MODE';
export const CHANGE_VALID = 'CHANGE_VALID';
export const REGISTER = 'REGISTER';